// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"887":"9c675538","938":"ab472e3b"}[chunkId] + ".chunk.js";
};